import {AutoCompleteItemValue} from '../../components/shared/nextgen/selector/types';

export interface VacationReportItem {
    id: number;
    employeeId: number;
    employeeName: string
    dateFrom: string;
    dateTo: string;
    comment?: string;
    state: VacationState;
    notifyNDaysInAdvance: number;
    notifyAll: boolean;
    approvers: VacationApproverReportItem[];
}

export interface VacationApproverDto {
    employeeId: number;
    approvedDate: string | null;
}

export interface VacationApproverReportItem {
    employeeId: number;
    employeeName: string;
    approved: boolean;
}

export type Vacation = {
    id: number;
    employeeId: number;
    dateFrom: string;
    dateTo: string;
    comment?: string;
    state: number;
    notifyNDaysInAdvance: number;
    notifyAll: boolean;
    approvers?: VacationApproverDto[];
}

export enum VacationState {
    Undefined = -1,
    WaitApprove = 1,
    Approved = 2,
    ApprovedByCurrentUser = 99
}

export function toVacationState(state: unknown): VacationState {
    return Number(state) as VacationState;
}

export function isRenderableVacationState(state: unknown): boolean {
    return isVacationWaitingApproval(state) || toVacationState(state) === VacationState.Approved;
}

export function isVacationWaitingApproval(state: unknown): boolean {
    const vacationState = toVacationState(state);
    return vacationState === VacationState.WaitApprove || vacationState === VacationState.ApprovedByCurrentUser;
}

export function CreateEmptyVacationReportItemByEmployee(
    employeeId: number, 
    employeeName: string): VacationReportItem {
    return ({
        id: 0,
        employeeId: employeeId,
        employeeName: employeeName,
        dateFrom: '',
        dateTo: '',
        comment: '',
        state: VacationState.Undefined,
        notifyNDaysInAdvance: 0,
        notifyAll: false,
        approvers: []
    });
}


export function CreateVacationReportItemByVacation(
    employeeId: number, 
    employeeName: string,
    vacation: Vacation,
    employeesById: Map<number, string> = new Map()): VacationReportItem {
    return ({
        id: vacation.id,
        employeeId: employeeId,
        employeeName: employeeName,
        dateFrom: vacation.dateFrom,
        dateTo: vacation.dateTo,
        comment: vacation.comment,
        state: toVacationState(vacation.state),
        notifyNDaysInAdvance: vacation.notifyNDaysInAdvance,
        notifyAll: vacation.notifyAll,
        approvers: (vacation.approvers ?? []).map((approver) => ({
            employeeId: approver.employeeId,
            employeeName: employeesById.get(approver.employeeId) ?? `Employee #${approver.employeeId}`,
            approved: approver.approvedDate != null,
        }))
    });
}

export interface VacationDateRangeFilter {
    startDate: string;
    endDate: string;
}

export interface VacationPropertyFilter {
    selectedEmployees: AutoCompleteItemValue[];
    selectedVacationStates: AutoCompleteItemValue[];
}
